import React, { useState } from "react";
import Header from '../../components/Header';
import TableComponent from '../../components/TableComponent';
import Dashboard from '../../components/Dashboard';
import PageHeaderComponent from '../../components/PageHeaderComponent';
import OmnitechQueries from '../../queries/OmnitechQueries'
import { useTranslation } from 'react-i18next';
import { useCubeQuery } from '@cubejs-client/react';
import { format } from 'date-fns'


const RSMRCheckingQuery = (isRefresh, setRefresh) => {
  const { t } = useTranslation();
  
  let item = {
    name: t('page.fnb.rsmrCheckingPage.name'),
    tableHeaders: {
      "RSMRChecking.id": { name: t('page.fnb.rsmrCheckingPage.tableHeader.id'), type: 'number'},
      "RSMRChecking.code": { name: t('page.fnb.rsmrCheckingPage.tableHeader.code'), type: 'string'},
      "RSMRChecking.status": { name: t('page.fnb.rsmrCheckingPage.tableHeader.status'), type: 'string'},
      "RSMRChecking.rsmr_category_count": { name: t('page.fnb.rsmrCheckingPage.tableHeader.rsmrCategoryCount'), type: 'number'},
      "RSMRChecking.rsmr_category": { name: t('page.fnb.rsmrCheckingPage.tableHeader.rsmrCategory'), type: 'string'},
    },
    grid: {xs: 12, lg: 12},
    export: { allowExport: true, filename: 'rsm_checking_export_' + format(new Date(), 'yyyyMMddHHmmss') }
  }
  let query = {
    ...OmnitechQueries.products.RSMRChecking.query,
  }
  if(isRefresh)
    query = {}
  const result = useCubeQuery(query, {resetResultSetOnChange: true})
  if(isRefresh)
    setRefresh(false)
  return { item, result }
}

const RSMRCheckingPage = () => {
  const { t } = useTranslation();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [ refresh1, setRefresh1 ] = useState(false);

  const { item, result }  = RSMRCheckingQuery(refresh1, setRefresh1)

  const refresh = () => {
    setRefresh1(true)
    setPage(0)
  }

  return ([
    <Header />,
    <PageHeaderComponent onClickFunc={refresh} refreshlabel={t('component.refresh')} headerTitle={t('component.header.menu.rsmrChecking')} />,
    <Dashboard>
      <TableComponent item={item} result={result} rowsPerPage={rowsPerPage} 
        setRowsPerPage={setRowsPerPage} page={page} setPage={setPage}/>
    </Dashboard>
  ]) 
};

export default RSMRCheckingPage;